<template>
  <div class="window-block block" :style="{ height: height}">
    <div v-if="showHeader" class="window-block__header">
      <div class="columns is-vcentered">
        <div class="column">
          <div v-if="title" v-html="title"></div>
          <slot v-else name="left-header"></slot>
        </div>
        <div class="column is-hidden-touch is-narrow">
          <slot name="right-header"></slot>
        </div>
      </div>
    </div>
    <hr v-if="showHeader">
    <div :style="{maxHeight: maxContentHeight}" class="window-block__body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    height: {
      type: String,
      defualt: 'auto',
    },
    maxContentHeight: {
      type: String,
      default: 'auto',
    },
  },
};
</script>

